export const UNAUTHORIZED_QUERY = 'UNAUTHORIZED';
